( function($) {

    var OrdersFilter = ( function($) {

        OrdersFilter = function(options) {
            var that = this;

            // DOM
            that.$wrapper = options["$wrapper"];
            that.$filters = that.$wrapper.find(".js-orders-filter")
            that.$orders = $(".s-orders-list .s-order-section");

            // DYNAMIC VARS
            that.filterClasslist = [];

            // INIT
            that.init();
        };

        OrdersFilter.prototype.init = function() {
            var that = this;

            that.$wrapper.on("click", ".js-orders-filter", function () {
                that.updateToggle($(this));
                that.updateClasslist();
                that.update();
            });
        }

        OrdersFilter.prototype.updateToggle = function($button) {
            var that = this,
                $button_toggle = $button.parents(".b-orders-filter__item").find("button.dropdown-toggle"),
                $buttons = $button.parent(".dropdown-menu").find("button"),
                text = $button.text(),
                active_class = "active";

            $buttons.removeClass(active_class);
            $button.addClass(active_class);
            $button_toggle.html(text);
        }

        OrdersFilter.prototype.updateClasslist = function($button) {
            var that = this;

            // Добавляем в массив классы фильтров, если это не all
            that.filterClasslist = [];
            that.$filters.each(function () {
                var filter = $(this).data("filter");
                if ($(this).hasClass("active") && filter !== "all") {
                    that.filterClasslist.push($(this).data("filter"));
                }
            });
        }

        OrdersFilter.prototype.update = function() {
            var that = this;

            // Показываем все заказы, т.к. фильтр пустой
            if (!that.filterClasslist.length) {
                that.$orders.removeClass("is-hidden");
                return;
            }

            // Показываем заказы по нужным классам
            var classes = that.filterClasslist.join(" ");
            that.$orders.each(function () {
                if ($(this).hasClass(classes)) {
                    $(this).removeClass("is-hidden");
                } else {
                    $(this).addClass("is-hidden");
                }
            });
        };

        return OrdersFilter;

    })(jQuery);

    window.waTheme.init.shop.OrdersFilter = OrdersFilter;

    var $ordersFilters = $("#js-orders-filter").removeAttr("id");
    if ($ordersFilters.length) {
        new window.waTheme.init.shop.OrdersFilter({
            $wrapper: $ordersFilters
        });
    }

})(jQuery);

